import { render, staticRenderFns } from "./unlockQuota_Free.vue?vue&type=template&id=5a246f64&scoped=true&"
import script from "./unlockQuota_Free.vue?vue&type=script&lang=js&"
export * from "./unlockQuota_Free.vue?vue&type=script&lang=js&"
import style0 from "./unlockQuota_Free.vue?vue&type=style&index=0&id=5a246f64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a246f64",
  null
  
)

export default component.exports